import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-340189d9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "branch" }
const _hoisted_2 = { class: "logo" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "topTitle" }, "AD不同年龄段的皮损分布及表现", -1))
const _hoisted_4 = { class: "boxWrap" }
const _hoisted_5 = { class: "iconOne" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "smallbox" }, "婴儿期（出生～2岁）", -1))
const _hoisted_7 = { class: "bottomWarp" }
const _hoisted_8 = { class: "leftBox" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "smallText" }, [
  /*#__PURE__*/_createTextVNode(" 多分布于两颊、额部、头皮和四肢伸侧 "),
  /*#__PURE__*/_createElementVNode("div", { class: "jiaobiao" }, "1,2")
], -1))
const _hoisted_10 = { class: "rightBox" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rightText" }, [
  /*#__PURE__*/_createTextVNode(" 皮疹以急性湿疹表现为主 "),
  /*#__PURE__*/_createElementVNode("div", { class: "jiaobiaop" }, "1")
], -1))
const _hoisted_12 = { class: "boxWrap" }
const _hoisted_13 = { class: "iconTwo" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "smallbox" }, "儿童期（2～12岁）", -1))
const _hoisted_15 = { class: "bottomWarp" }
const _hoisted_16 = { class: "leftBox" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "smallText" }, [
  /*#__PURE__*/_createTextVNode(" 多分布于面颈、肘窝、腘窝和小腿伸侧 "),
  /*#__PURE__*/_createElementVNode("div", { class: "jiaobiao" }, "1,2")
], -1))
const _hoisted_18 = { class: "rightBox" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rightText" }, [
  /*#__PURE__*/_createTextVNode(" 以亚急性和慢性皮损表现为主 "),
  /*#__PURE__*/_createElementVNode("div", { class: "jiaobiaobz" }, "1"),
  /*#__PURE__*/_createTextVNode(" ,皮疹往往干燥肥厚,有明显苔藓样变 "),
  /*#__PURE__*/_createElementVNode("div", { class: "jiaobiaob" }, "1")
], -1))
const _hoisted_20 = { class: "boxWrap" }
const _hoisted_21 = { class: "iconThree" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "smallbox" }, "青少年与成人期（>2岁）", -1))
const _hoisted_23 = { class: "bottomWarp" }
const _hoisted_24 = { class: "leftBox" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "smallText" }, [
  /*#__PURE__*/_createTextVNode(" 多分布于在肘窝、腘窝、颈前等部位 "),
  /*#__PURE__*/_createElementVNode("div", { class: "jiaobiaobw" }, "1,2"),
  /*#__PURE__*/_createTextVNode(" 也可发生于躯干、四肢、面部、手部 "),
  /*#__PURE__*/_createElementVNode("div", { class: "jiaobiaosb" }, "1")
], -1))
const _hoisted_26 = { class: "rightBox" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rightText" }, [
  /*#__PURE__*/_createTextVNode(" 与儿童期类似亚急性和慢性 "),
  /*#__PURE__*/_createElementVNode("div", { class: "jiaobiaomx" }, "1")
], -1))
const _hoisted_28 = { class: "home" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "paper" }, [
  /*#__PURE__*/_createElementVNode("span", null, "1.Langan SM, et al. Lancet. 2020;396(10247):345-360. "),
  /*#__PURE__*/_createElementVNode("span", null, " 2.中华医学会皮肤性病学分会免疫学组,特应性皮炎协作研究中心. 中华皮肤科杂志,2020,53(2):81-88. ")
], -1))
const _hoisted_30 = { class: "ip" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_question = _resolveComponent("question")!
  const _component_correctTwo = _resolveComponent("correctTwo")!
  const _component_reason = _resolveComponent("reason")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_toNav = _resolveComponent("toNav")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_van_image, {
          width: "2.1333rem",
          height: ".6667rem",
          src: require('../assets/logo.png')
        }, null, 8, ["src"])
      ]),
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_van_image, {
            width: "1.4467rem",
            height: "1.6933rem",
            src: require('../assets/tu3.png')
          }, null, 8, ["src"])
        ]),
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_van_image, {
              width: "1.9333rem",
              height: "1.2267rem",
              src: require('../assets/pi1.jpg')
            }, null, 8, ["src"]),
            _createVNode(_component_van_image, {
              width: "1.9333rem",
              height: "1.2267rem",
              src: require('../assets/pi2.jpg')
            }, null, 8, ["src"]),
            _hoisted_9
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_van_image, {
              class: "rightpi",
              width: "1.9333rem",
              height: "1.2267rem",
              src: require('../assets/pi3.jpg')
            }, null, 8, ["src"]),
            _hoisted_11
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_van_image, {
            width: ".8867rem",
            height: "1.3933rem",
            src: require('../assets/tu1.png')
          }, null, 8, ["src"])
        ]),
        _hoisted_14,
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_van_image, {
              width: "1.9333rem",
              height: "1.2267rem",
              src: require('../assets/pi4.jpg')
            }, null, 8, ["src"]),
            _createVNode(_component_van_image, {
              width: "1.9333rem",
              height: "1.2267rem",
              src: require('../assets/pi5.jpg')
            }, null, 8, ["src"]),
            _hoisted_17
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_van_image, {
              class: "rightpipi",
              width: "3.3rem",
              height: "1.2267rem",
              src: require('../assets/pi6.jpg')
            }, null, 8, ["src"]),
            _hoisted_19
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _createVNode(_component_van_image, {
            width: ".8867rem",
            height: "1.3933rem",
            src: require('../assets/tu2.png')
          }, null, 8, ["src"])
        ]),
        _hoisted_22,
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createVNode(_component_van_image, {
              width: "1.9333rem",
              height: "1.2267rem",
              src: require('../assets/pi7.jpg')
            }, null, 8, ["src"]),
            _createVNode(_component_van_image, {
              width: "1.9333rem",
              height: "1.2267rem",
              src: require('../assets/pi8.jpg')
            }, null, 8, ["src"]),
            _hoisted_25
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createVNode(_component_van_image, {
              class: "rightpipi",
              width: "3.3rem",
              height: "1.2267rem",
              src: require('../assets/pi6.jpg')
            }, null, 8, ["src"]),
            _hoisted_27
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_28, [
        _hoisted_29,
        _createElementVNode("div", _hoisted_30, [
          _createVNode(_component_van_image, {
            onClick: $options.showPopup,
            width: "2.5733rem",
            height: "2.5733rem",
            src: require('../assets/jixu.png')
          }, null, 8, ["onClick", "src"]),
          _createVNode(_component_van_image, {
            class: "finger",
            width: "1.28rem",
            height: "1.28rem",
            src: require('../assets/dong.gif')
          }, null, 8, ["src"])
        ]),
        _createVNode(_component_van_popup, {
          show: $data.show,
          "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => (($data.show) = $event))
        }, {
          default: _withCtx(() => [
            ($data.flag == 'question')
              ? (_openBlock(), _createBlock(_component_question, {
                  key: 0,
                  onOnChanged: $options.updateChanged,
                  postaimqus: $data.postaimqus
                }, null, 8, ["onOnChanged", "postaimqus"]))
              : _createCommentVNode("", true),
            ($data.flag == 'correct')
              ? (_openBlock(), _createBlock(_component_correctTwo, {
                  key: 1,
                  onOnChanged: $options.updateCorrect,
                  postaimqus: $data.postaimqus,
                  correct: $data.correct
                }, null, 8, ["onOnChanged", "postaimqus", "correct"]))
              : _createCommentVNode("", true),
            ($data.flag == 'reason')
              ? (_openBlock(), _createBlock(_component_reason, {
                  key: 2,
                  onOnChanged: $options.reasonCorrect,
                  postaimqus: 2
                }, null, 8, ["onOnChanged"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["show"])
      ])
    ]),
    _createVNode(_component_toNav, { menu: 2 })
  ], 64))
}